<template>
    <div class="survey">
        <b-modal
            id="survey-modal"
            ref="survey-modal"
            :title="exam_template.name"
            :title-class="['h4','text-white']"
            hide-header-close
            no-close-on-esc
            centered
            size="lg"
            header-bg-variant="dark"
            header-text-variant="secondary"
            cancel-title="Cancelar"
            @hidden="hiddenModal"
            no-close-on-backdrop
            ok-disabled 
            cancel-disabled
            >
            <!-- FORM survey -->
            <div v-if="test.id">
              <p class="texf-justify" v-html="exam_template.instructions"></p>
              <b-card>
                <b-form name="survey_form" id="survey_form" ref="survey_form">
                  <fieldset :disabled="formDisabled || final_score">
                    <b-tabs pills card vertical v-model="tabIndex" small>
                      <b-tab v-for="(item, index) in questions" v-bind:key="index" :title="(index+1)+' de '+questions.length">
                        <b-card-body>
                          <b-form-group 
                            :label="item.question" 
                            description="Seleccione" 
                            label-size="md" 
                            :label-class="['h4','text-primary']"
                          >
                            <b-form-radio-group
                              v-model="form[index]"
                              :options="item.answer_options_lov"
                              stacked
                              :name="'question_'+index"
                              :id="'question_'+index"
                              @change="radioChange"
                              @input="currentItem(item)"
                              :required="is_mandatory"
                            ></b-form-radio-group>
                          </b-form-group>
                        </b-card-body>
                      </b-tab>
                    </b-tabs>
                    <b-form-invalid-feedback :state="complete">
                      Falta al menos una respuesta
                    </b-form-invalid-feedback>
                  </fieldset>
                </b-form>
                <b-row>
                  <b-col class="md-6">
                    <div class="text-left">
                      <b-button-group class="mb-2" size="sm">
                        <b-button @click="tabIndex--" variant="warning">Anterior</b-button>
                        <b-button @click="tabIndex++" variant="warning">Siguiente</b-button>
                      </b-button-group>
                    </div>
                  </b-col>
                  <!-- <b-col class="text-right md-6">
                    <b-button variant="light" disabled class="btn-sm" block>
                      <b-spinner variant="primary" small></b-spinner> {{this.time_elapsed}} Minuto(s)
                    </b-button>
                  </b-col> -->
                </b-row>

              </b-card>
            </div>
            <template v-slot:modal-footer>
              <span class="text-danger text-center" v-if="assistant_idError">{{assistant_idError}}</span>
              <b-button-group class="float-left" size="md" v-if="!formDisabled">
                <b-button @click="buttonPress" class="btn-success">
                  {{btnTitle}}
                </b-button>
              </b-button-group>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'SurveyForm',
  props: {
    assistant_key_id: { type: String, default: null },
    assistant_id: { type: Number, default: null },
    survey_id: { type: Number, default: 13 },
    is_mandatory: { type: Boolean, default: false } // force contest the survey
  },
  created() {
    //this.timer = setInterval(this.autoIncrementTimer, 60000)
  },
  data() {
      return {
        exam_template: {
          id: null,
          event_id: null,
          name: null,
          instructions: null,
          description: null,
          start_date: null,
          end_date: null,
          order: null,
          score_to_pass: null,
          minutes_available: null,
          maximum_attempts: null,
        },
        test: {
          id:null,
          assistant_id: null,
          key_id: null,
          minutes_elapsed: null,
          final_score: null,
        },
        questions: [],
        formDisabled: false,
        errors: [],
        tabIndex: 0,
        form: {},
        complete: true,
        time_elapsed: 0,
        final_score: null,
        answereds: []
      }
  },
  methods: {
    /* autoIncrementTimer() {
      if (this.time_elapsed <= 0) {
        return
      }
      this.time_elapsed --
    }, */
    currentItem(value) {
      this.answereds.push(value.id)
    },
    radioChange(checked) {
      this.tabIndex++
    },
    loadExam() {
      let loader = this.$loading.show()
      let url = '/catalog/exam_templates/get_exam'
      let method = 'post'
      this.$store.dispatch(method, {'url':url, data: {id: this.survey_id, event_key_id: 'x', locale: 'es'}, headers:{}})
        .then((resp) => {
          loader.hide()
          this.exam_template = resp.data
          this.time_elapsed = this.exam_template.minutes_available
          this.questions = resp.data.questions
          this.showModal()
          this.$nextTick(() => {
            //this.loadQuestions()
            this.startTest()
          })
        })
        .catch(err => {
          loader.hide()
          this.hiddenModal({
            'text': 'No hay encuesta disponible',
            'title': 'Error'
          })
        })
    },
    startTest() {
      let loader = this.$loading.show()
      let url = '/catalog/tests'
      let method = 'post'
      this.errors = []
      this.$store.dispatch(method, {'url':url, data: {'assistant_id': this.assistant_id, 'skip_max_attempts': 1, 'exam_template_id': this.exam_template.id}, headers:{}})
        .then((resp) => {
          this.test = resp.data
          loader.hide()
          this.formDisabled = false
          this.$nextTick(() => {
            
          })
        })
        .catch(err => {
          loader.hide()
          this.errors = err.errors
          this.formDisabled = false
          if(err.error) alert(err.error)
        })
    },
    loadQuestions() {
      let url = '/catalog/questions/get_questions'
      let method = 'post'
      this.$store.dispatch(method, {'url':url, data: {exam_template_id: this.exam_template.id, locale:this.$i18n.locale}, headers:{}})
        .then((resp) => {
          this.questions = resp.data
          this.$nextTick(() => {
            this.startTest()
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    showModal() {
      this.$bvModal.show('survey-modal')
    },
    hiddenModal(msg) {
      if(msg) this.$emit('closed', msg)
      else this.$emit('closed')
    },
    buttonPress() {
      this.formDisabled = true
      if(!this.assistant_idError) this.sendExam()
      else this.hiddenModal()
    },
    sendExam: function() {
      let loader = this.$loading.show()
      if(this.canSend) { 
        this.complete = true
        this.errors = []
        let url = '/catalog/answer_tests/responses'
        let method = 'post'
        this.$store.dispatch(method, {'url':url, data: {test_key_id:this.test.key_id, answer_options: Object.values(this.form)}, headers:{}})
          .then((resp) => {
            loader.hide()
            this.formDisabled = false
            this.final_score = resp.data.final_score
            this.$nextTick(() => {
              clearInterval(this.timer)
              this.hiddenModal({
                'text': 'Gracias por su atención.',
                'title': 'Encuesta recibida'
              }) 
            })
          })
          .catch(err => {
            loader.hide()
            this.formDisabled = false
            this.errors = err.errors
            //if(err.error) alert(err.error)
          })
      } else {
        loader.hide()
        alert('Debe contestar todas las preguntas')
        this.complete = false
        this.formDisabled = false
      }
      //Object.values(this.form)
    },
  },
  beforeMount() {
    
  },
  mounted() {
    this.loadExam()
  },
  computed: {
    btnTitle: function() {
      if(this.assistant_idError) {
        return 'Cerrar'
      } else return 'Enviar'
    },
    assistant_idError: function () {
      if(this.errors && this.errors.assistant_id) return this.errors.assistant_id[0]
      return null
    },
    canSend: function () {
      if(this.is_mandatory) {
        if(([...new Set(this.answereds)].length == this.questions.length)) return true
        else return false
      } return true
    }
  },
})
</script>

<style lang="scss" scoped>
  @import '../../styles/app';
</style>